import { JsonConverter, JsonCustomConvert } from 'json2typescript';

@JsonConverter
export class NumberToBooleanAdapter implements JsonCustomConvert<boolean> {
    serialize(value: boolean): any {
        return !!value ? '1' : '0';
    }

    deserialize(value: any): boolean {
        return value === '1';
    }
}
